export enum WhenIssuedIndicators {
    'Regular Way',
    'When Issued',
}

export enum Exchanges {
    'New York Stock Exchange',
    'NYSE Amex Equities Exchange',
    'OTC Exchange',
}

export enum CnsEligibilityIndicators {
    'Non-CNS Eligible',
    'CNS Eligible',
    Suspended,
}

export enum SpecialTradeIndicators {
    'No Special Trade Processing',
    'Foreign Security Netting',
    'NSCC Special Trade' = 3,
}

export enum UnitOfTrades {
    '1-Share Round-Lot',
    '10-Share Round-Lot',
    '25-Share Round-Lot',
    '50-Share Round-Lot',
    '100-Share Round-Lot',
    '1000-Share Round-Lot',
}

export enum TradingStatuses {
    Active = 1,
    Suspended = 2,
}

export enum SecurityTypes {
    'Common Stock' = 6,
}

export interface ISettingsSecuritiesDto {
    id: number;
    cusip: string;
    whenIssuedIndicator: WhenIssuedIndicators;
    exchange: Exchanges;
    symbol: string;
    cnsEligibilityIndicator: CnsEligibilityIndicators;
    specialTradeIndicator: SpecialTradeIndicators;
    description: string;
    addedDate: string;
    modifyDate: string;
    enabled: boolean;
    type: SecurityTypes;
    sourceId: string;
    unitOfTrade: UnitOfTrades;
    tradingStatus: TradingStatuses;
}
